import React from "react"
//Grahql
import { gql, useQuery } from "@apollo/client"

import ParticipantSidebar from "../../components/sidebars/ParticipantSidebar"
import styles from "../../styles/Page-with-Sidebar.module.css"
import { LoaderMedium } from "../../components/Loaders"

const GET_PARTICIPANTS_BY_NUMBER = gql`
  query ParticipantByNumber($phone: String!) {
    participant: participantByNumber(phone: $phone) {
      participant_id
      participant_alias
      participant_name_first
      participant_name_last
      participant_membership_status
      participant_name_preferred
    }
  }
`

export default function DemoPhonePage() {
  const { data, loading } = useQuery(GET_PARTICIPANTS_BY_NUMBER, {
    variables: { phone: "916-636-2888" },
    onCompleted: ({ participant }) => {
    },
  })

  if (loading) return <LoaderMedium />

  return (
    <div className={styles.wrapper}>
      <div className={styles.sidebar}>
        <ParticipantSidebar />
      </div>
      <div className={styles.content}>
        <h1>Demo Phone Page</h1>
        <p>
          <strong>
            Check the file src/pages/DemoPage/DemoPhone.js to get started on
            getting React's context variables and a GraphQL query example.
          </strong>
        </p>

        <h3>Context variables:</h3>
        <p>
          <strong>Participant ID (PID)</strong>: {`${data.participant.participant_id}`}
        </p>
        <p>
          <strong>Participant First Name</strong>:{" "}
          {`${data.participant.participant_name_first}`}
        </p>
        <p>
          <strong>Participant Last Name</strong>:{" "}
          {`${data.participant.participant_name_last}`}
        </p>
      </div>
    </div>
  )
}
